module.exports = __webpack_public_path__ + "static/media/pf.325520a1.svg";